export interface BuildGradientStyle {
    backgroundColor?: string
    backgroundImage?: string
}

export type GradientStyleDirection = '180deg' | '90deg' | 'to right' | 'to bottom'

export const buildGradientStyle = (
    colors?: string[],
    direction: GradientStyleDirection = 'to right'
): BuildGradientStyle => {
    const fallbackColors = ['#FFFFFF']
    const appliedColors = colors && colors.length > 0 ? colors : fallbackColors

    if (appliedColors.length === 1) {
        return { backgroundColor: appliedColors[0] }
    } else if (appliedColors.length > 1) {
        return { backgroundImage: `linear-gradient(${direction}, ${appliedColors.join(', ')})` }
    }

    return { backgroundColor: 'transparent' }
}
